<template lang="pug">
    .content(v-if="contents && contents.length")
        .cards
            CardBody(
                v-for="content in contents"
                :key="content.id"
                :content="content"
            )
</template>
<script>
//import Components
import CardBody from './CardBody'

export default {
    name: "Card",
    components: {
        CardBody
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    computed: {
        contents() {
            return this.section.contents || []
        }
    }
}
</script>
<style lang="sass" scoped>
@import "~bulma/sass/utilities/mixins"
@import '~@/assets/sass/variables'

.cards
    display: flex
    // grid-template-rows: auto
    // gap: 2rem
    flex-direction: row
    justify-content: center
    align-items: flex-start
    flex-wrap: wrap
    ::v-deep .card
        width: 255px
        margin: 0 25px 25px
    // grid-row-gap: 3rem
    +mobile
        justify-content: center
        align-items: center
        flex-direction: column
        ::v-deep .card
            margin-bottom: 25px
        // grid-template-columns: repeat(2, 255px)
    +desktop
        // gap: 1rem
        // grid-template-columns: repeat(4, 255px)

</style>
